import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "custom-component"
};
import commonTxt from './commonTxt.vue';
import { onMounted } from 'vue';
export default {
  __name: 'eText',
  props: {
    elementContent: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    element: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  emits: ['loaded'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 组件 */
    var props = __props;
    var emit = __emit;
    onMounted(function () {
      emit('loaded', 'eText');
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(commonTxt, {
        "initial-content": __props.elementContent.content
      }, null, 8, ["initial-content"])]);
    };
  }
};